import { StandardEvents } from '@shopify/events';
import { ThemeEvents } from '@theme/events';

export class PhoneCaseCartFeedback extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.sequence ??= 0;
    this.formComponent = this.closest('product-form-component');
    this.root = this.closest('.shopify-section');
    this.message = this.querySelector('[data-pc-cart-message]');
    this.link = this.querySelector('[data-pc-cart-link]');
    if (!this.formComponent || !this.root || !this.message || !this.link) return;
    const options = { signal: this.controller.signal };
    this.formComponent.addEventListener(StandardEvents.cartLinesUpdate, (event) => this.onCartUpdate(event), options);
    this.root.addEventListener(StandardEvents.productSelect, () => this.reset(), options);
    this.root.addEventListener('change', (event) => {
      if (event.target?.closest?.('variant-picker') || this.formComponent.contains(event.target)) this.reset();
    }, { ...options, capture: true });
    this.formComponent.addEventListener('input', () => this.reset(), options);
    this.formComponent.addEventListener(ThemeEvents.quantitySelectorUpdate, () => this.reset(), options);
    window.addEventListener('pageshow', (event) => { if (event.persisted) this.reset(); }, options);
    window.addEventListener('popstate', () => this.reset(), options);
    this.reset();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.sequence += 1;
  }

  reset() {
    this.sequence += 1;
    if (this.message) this.message.textContent = '';
    if (this.link) this.link.hidden = true;
    this.removeAttribute('data-added');
  }

  onCartUpdate(event) {
    if (event.target !== this.formComponent || !event.promise?.then) return;
    this.reset();
    const sequence = this.sequence;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || sequence !== this.sequence || detail?.didError !== false || detail?.source !== 'product-form-component') return;
      this.setAttribute('data-added', '');
      this.message.textContent = this.dataset.addedMessage;
      this.link.hidden = false;
    }).catch(() => {});
  }
}

if (!customElements.get('pc-cart-feedback')) customElements.define('pc-cart-feedback', PhoneCaseCartFeedback);
